import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ClientesService } from './clientes.service';
import * as decode from 'jwt-decode';
import { JwtHelper} from 'angular2-jwt'

@Injectable()
export class AuthService {

  

  public loggedIn:BehaviorSubject<boolean>=new BehaviorSubject<boolean>(false);
  usuarioActivo;
  public logeado:boolean;
  cont:number=0;
  loading:boolean=false;
  
  get isLoggedIn() {
    return this.loggedIn.asObservable(); // {2}
  }




  esCliente():boolean{
    if(this.isAuthenticated()){
      if(decode(this.getToken()).tipo=="C"){
        return true;
      }else{
        return false;
      }
    }
    
  }

  esClientePymes():boolean{
    if(this.isAuthenticated()){
      if(decode(this.getToken()).tipo=="CP"){
        return true;
      }else{
        return false;
      }
    }
  }

  esAdminPymes():boolean{
    if(this.isAuthenticated()){
      if(decode(this.getToken()).tipo=="adminP"){
        return true;
      }else{
        return false;
      }
    }
  }

  esAdmin():boolean{
    if(this.isAuthenticated()){
      if(decode(this.getToken()).tipo=="admin"){
        return true;
      }else{
        return false;
      }
    }
  }

  esInterviniente():boolean{
    if(this.isAuthenticated()){
      if(decode(this.getToken()).tipo=="interviniente"){
        return true;
      }else{
        return false;
      }
    }
  }
  constructor(private clientesService:ClientesService, private router: Router, private http:HttpClient,
    private jwtHelper:JwtHelper) {
    
    if(this.isAuthenticated()){
      let user=this.getToken();
      this.usuarioActivo=decode(this.getToken()).data;
      this.loggedIn.next(true);
      
    }
  }
    
  loginCliente(email:string,password:string){
    let header=new HttpHeaders();
    
   
    return this.http.post("https://app.solucionlegal.es/API/index.php/Auth/loginCliente",{email,password},{headers:header})
    .map(resp=>{
      
      if(resp["err"]==true){
        
        return resp;
      
      }else{
        let token=resp["token"];
        localStorage.setItem("token", token);
        let tokenPayload=decode(token);
        
        this.usuarioActivo=tokenPayload.data;
        this.usuarioActivo["CLgestoria"]=parseInt(this.usuarioActivo["CLgestoria"]);
        this.loggedIn.next(true);
        this.clientesService.clienteActual=this.usuarioActivo;
        return resp;
      }
    });
  }

  loginAdmin(usuario:string, password:string){
    let header=new HttpHeaders();
    header.set("Content-Type", "application/json");
   
    return this.http.post("https://app.solucionlegal.es/API/index.php/Auth/loginAdmin",{usuario,password},{headers:header})
            .map(resp=>{
              
              if(resp["err"]==true){
                
                return false;
              }else{
                let token=resp["token"];
                localStorage.setItem("token", token);
                let tokenPayload=decode(token);
                
                this.usuarioActivo=tokenPayload.data;
                this.loggedIn.next(true);
                return true;
              }
            });
  }

  loginInterviniente(usuario:string, password:string){
    let header=new HttpHeaders();
    header.set("Content-Type", "application/json");
   
    return this.http.post("https://app.solucionlegal.es/API/index.php/Auth/loginInterviniente",{usuario,password},{headers:header})
            .map(resp=>{
              
              if(resp["err"]==true){
                return false;
                
              }else{
                let token=resp["token"];
                localStorage.setItem("token", token);
                let tokenPayload=decode(token);
                this.usuarioActivo=tokenPayload.data;
                this.loggedIn.next(true);
                
                return true;
              }
            });
  }

  loginAdminPyme(usuario:string, password:string){
    let header=new HttpHeaders();
    header.set("Content-Type", "application/json");
   
    return this.http.post("https://app.solucionlegal.es/API/index.php/Auth/loginAdminPyme",{usuario, password},{headers:header})
            .map(resp=>{
              
              if(resp["err"]==true){
                return false;
              }else{
                let token=resp["token"];
                localStorage.setItem("token", token);
                let tokenPayload=decode(token);
                this.usuarioActivo=tokenPayload.data;
                this.loggedIn.next(true);
                return true;
              }
            });
  }
  
  loginClientePyme(email:string, password:string){
    let header=new HttpHeaders();

    return this.http.post("https://app.solucionlegal.es/API/index.php/auth/loginClientePymes",{email,password},{headers:header})
    .map(resp=>{
      
      
      if(resp["err"]==true){
        return resp;
      
      }else{
        
        let token=resp["token"];
        localStorage.setItem("token", token);
        let tokenPayload=decode(token);
        
        this.usuarioActivo=tokenPayload.data;
        this.usuarioActivo["CLgestoria"]=parseInt(this.usuarioActivo["CLgestoria"]);
        this.loggedIn.next(true);
        this.clientesService.clienteActual=this.usuarioActivo;
        return resp;
      }
    });
    
  }


  logout(){
    if (this.esAdmin() || this.esInterviniente()){
      this.router.navigate(['/loginAdmin']);
    }else if(this.esAdminPymes()){
      this.router.navigate(['/loginAdminPymes']);
    }else{
      this.router.navigate(['/login']);
    }
    this.usuarioActivo=null;
    localStorage.removeItem("token");
    this.loggedIn.next(false);

    
  }


  recuperarPassCliente(cliente){

    let body=JSON.stringify(cliente);

    return this.http.post(`https://app.solucionlegal.es/API/index.php/Auth/recuperarPassCliente`, body)
    .map(resp=>{
      return resp;
    });
  }

  recuperarPassClientePymes(cliente){

    let body=JSON.stringify(cliente);

    return this.http.post(`https://app.solucionlegal.es/API/index.php/Auth/recuperarPassClientePymes`, body)
    .map(resp=>{
      return resp;
    });
  }

  recuperarPassUsuarioInterviniente(usuario){
    let body=JSON.stringify(usuario);

    return this.http.post(`https://app.solucionlegal.es/API/index.php/Auth/recuperarPassUsuarioInterviniente`, body)
    .map(resp=>{
      return resp;
    })
  }

  getToken(){
    return localStorage.getItem("token");
  }

  isAuthenticated(){
    let token=this.getToken();
    if(token){
      return !this.jwtHelper.isTokenExpired(token);
    }else{
      return false;
    }
  }

  refreshToken(){
    if(this.isAuthenticated()){
        let token=this.getToken();
        return this.http.post(`https://app.solucionlegal.es/API/index.php/Auth/refreshToken`, {token}, {responseType: 'text'})
        .map(resp=>{
          localStorage.setItem("token", resp);
          return true;
        });
    }else{
      this.logout();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts